import React from 'react';
import './Icon.css';

// Import SVG files as React components
import { ReactComponent as AddIcon } from '../../Icons/Add.svg';
import { ReactComponent as CheckIcon } from '../../Icons/Check.svg';
import { ReactComponent as DownloadIcon } from '../../Icons/Download.svg';
import { ReactComponent as UploadIcon } from '../../Icons/Upload.svg';
import { ReactComponent as ExpandMoreIcon } from '../../Icons/Expand more.svg';
import { ReactComponent as MoreVertIcon } from '../../Icons/More vert.svg';
import { ReactComponent as FolderIcon } from '../../Icons/Folder.svg';
import { ReactComponent as CreateNewFolderIcon } from '../../Icons/Create new folder.svg';
import { ReactComponent as Stat1Icon } from '../../Icons/Stat 1.svg';
import { ReactComponent as StatMinus1Icon } from '../../Icons/Stat minus 1.svg';
import { ReactComponent as DarkModeIcon } from '../../Icons/Dark mode.svg';
import { ReactComponent as DarkModeActiveIcon } from '../../Icons/Dark mode active.svg';
import { ReactComponent as LightModeIcon } from '../../Icons/Light mode.svg';
import { ReactComponent as LightModeActiveIcon } from '../../Icons/Light mode active.svg';
import { ReactComponent as SystemModeIcon } from '../../Icons/System mode.svg';
import { ReactComponent as SystemModeActiveIcon } from '../../Icons/System mode active.svg';
import { ReactComponent as ChevronRightIcon } from '../../Icons/Chevron right.svg';
import { ReactComponent as ExpandLessIcon } from '../../Icons/Expand less.svg';
import { ReactComponent as FolderClosedIcon } from '../../Icons/Folder closed.svg';
import { ReactComponent as FolderOpenIcon } from '../../Icons/Folder open.svg';
import { ReactComponent as CloseIcon } from '../../Icons/Close.svg';
import { ReactComponent as XIcon } from '../../Icons/X.svg';
import { ReactComponent as AppIcon } from '../../Icons/App.svg';
import { ReactComponent as WarningIcon } from '../../Icons/Warning.svg';
import { ReactComponent as DeleteForeverIcon } from '../../Icons/Delete forever.svg';
import { ReactComponent as ColorSlidersIcon } from '../../Icons/Color sliders.svg';
import { ReactComponent as LockIcon } from '../../Icons/Lock.svg';
import { ReactComponent as LockOpenIcon } from '../../Icons/Lock open.svg';
import { ReactComponent as HelpIcon } from '../../Icons/Help.svg';

export const Icon = ({ 
  name, 
  size = 'medium', 
  className = '',
  style = {}
}) => {
  const getIconComponent = (iconName) => {
    const iconMap = {
      'add': AddIcon,
      'check': CheckIcon,
      'download': DownloadIcon,
      'upload': UploadIcon,
      'expand-more': ExpandMoreIcon,
      'more-vert': MoreVertIcon,
      'folder': FolderIcon,
      'create-new-folder': CreateNewFolderIcon,
      'stat-1': Stat1Icon,
      'stat-minus-1': StatMinus1Icon,
      'dark-mode': DarkModeIcon,
      'dark-mode-active': DarkModeActiveIcon,
      'light-mode': LightModeIcon,
      'light-mode-active': LightModeActiveIcon,
      'system-mode': SystemModeIcon,
      'system-mode-active': SystemModeActiveIcon,
      'chevron-right': ChevronRightIcon,
      'expand-less': ExpandLessIcon,
      'close': CloseIcon,
      'x': XIcon,
      'app': AppIcon,
      'folder-closed': FolderClosedIcon,
      'folder-open': FolderOpenIcon,
      'warning': WarningIcon,
      'delete-forever': DeleteForeverIcon,
      'color-sliders': ColorSlidersIcon,
      'lock': LockIcon,
      'lock-open': LockOpenIcon,
      'help': HelpIcon
    };
    return iconMap[iconName];
  };

  const IconComponent = getIconComponent(name);
  const baseClass = 'icon';
  const sizeClass = `icon--${size}`;
  const combinedClassName = [baseClass, sizeClass, className].filter(Boolean).join(' ');

  return (
    <span className={combinedClassName} style={style}>
      <IconComponent />
    </span>
  );
};
